// 9.18.10.4 · D-830 — what an archive may ask of the device before it is
// refused. A person's own Instagram download can run to several gigabytes
// because of videos, so the ceilings are generous; what they stop is an
// archive built to exhaust memory, storage or time.

export type ZipLimits = {
  /** The archive file itself. */
  maxArchiveBytes: number;
  maxEntries: number;
  /** The central directory is read into memory at once. */
  maxCentralDirectoryBytes: number;
  maxNameBytes: number;
  /** One entry, uncompressed. Larger entries are listed but cannot be read. */
  maxEntryBytes: number;
  /** All entries together, uncompressed. */
  maxTotalUncompressedBytes: number;
  /** Uncompressed / compressed above this, on an entry over `ratioFloorBytes`, means a bomb. */
  maxCompressionRatio: number;
  ratioFloorBytes: number;
  /** A text entry (JSON) read into memory. */
  maxTextBytes: number;
};

const GIB = 1024 * 1024 * 1024;
const MIB = 1024 * 1024;

export const DEFAULT_ZIP_LIMITS: ZipLimits = {
  maxArchiveBytes: 32 * GIB,
  maxEntries: 200_000,
  maxCentralDirectoryBytes: 64 * MIB,
  maxNameBytes: 1024,
  // The video upload ceiling (api/src/media-policy.ts, 9.2.2).
  maxEntryBytes: 1 * GIB,
  maxTotalUncompressedBytes: 64 * GIB,
  // Text compresses perhaps 10–20 times and photos hardly at all; bombs run to
  // thousands. 200 leaves room for odd JSON and still refuses a bomb.
  maxCompressionRatio: 200,
  ratioFloorBytes: 10 * MIB,
  maxTextBytes: 64 * MIB,
};
